"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkAcceptCreatePayloadSchema = exports.LinkAcceptObjectSchema = void 0;
const zod_1 = require("zod");
const thread_1 = require("../thread");
exports.LinkAcceptObjectSchema = zod_1.z
    .object({
    object: zod_1.z.literal('link_accept'),
    data: thread_1.ThreadCreatePayloadSchema,
})
    .openapi('LinkAcceptObject');
// Create
exports.LinkAcceptCreatePayloadSchema = zod_1.z
    .object({
    token: zod_1.z.string(),
})
    .openapi('LinkAcceptCreatePayload');
//# sourceMappingURL=linkAcceptSchema.js.map